const LINKS = [
  { label: 'For coaches',  href: '#features' },
  { label: 'For clubs',    href: '/org/signup' },
  { label: 'Features',     href: '#features' },
  { label: 'Pricing',      href: '#pricing' },
  { label: 'Developers',   href: '/developers' },
  { label: 'Privacy',      href: '/privacy' },
  { label: 'Terms',        href: '/terms' },
]

export const HomepageFooter = () => (
  <footer className="px-8 py-10" style={{ background: '#13201B' }}>
    <div className="max-w-[1100px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
      <span className="text-[22px] font-bold" style={{ fontFamily: 'var(--font-caveat)', color: '#fff' }}>
        chalk<span style={{ color: '#F5E642' }}>.</span>
      </span>
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
        {LINKS.map(link => (
          <a key={link.label} href={link.href} className="text-[13px] transition-colors hover:text-white" style={{ color: '#A19A8E' }}>
            {link.label}
          </a>
        ))}
      </div>
      <span className="text-[13px]" style={{ color: '#A19A8E' }}>© 2026 Chalk Sports</span>
    </div>
  </footer>
)
